import request from '@/utils/request';
import { cohortSelectionVisualisationEndpoint } from '@/constants/urls';
import { removeUUIDsFromCohortClauses } from '../../clauses/state/state';
import { cohortChart } from '../constants';

const selectionVisualisation = (variables, name, clauses, chartType) => (
  request({
    url: cohortSelectionVisualisationEndpoint(chartType),
    data: {
      ...variables,
      queries: [{ name, clauses: removeUUIDsFromCohortClauses(clauses, true, false) }],
    },
    method: 'POST',
  })
);

const barChart = ({ xAxis }, clauses) => (
  selectionVisualisation(
    { column: xAxis.value },
    `Bar chart query for ${xAxis.value}`,
    clauses,
    cohortChart.BAR,
  )
);

const stackedBarChart = ({ xAxis }, clauses) => (
  selectionVisualisation(
    { column: xAxis.value },
    `Stacked bar chart query for ${xAxis.value}`,
    clauses,
    cohortChart.STACKED_BAR,
  )
);

const boxPlot = ({ xAxis, yAxis }, clauses) => (
  selectionVisualisation(
    { x_axis_column: xAxis.value, y_axis_column: yAxis.value },
    `Box plot chart query for ${xAxis.value}, ${yAxis.value}`,
    clauses,
    cohortChart.BOX_PLOT,
  )
);

const histogram = ({ bins, yAxis }, clauses) => (
  selectionVisualisation(
    { column: yAxis.value, bins: bins.value },
    `Histogram query for ${yAxis.value}`,
    clauses,
    cohortChart.HISTOGRAM,
  )
);

const SelectionVisualisationService = {
  barChart,
  stackedBarChart,
  boxPlot,
  histogram,
};

export default SelectionVisualisationService;
